import React, { useEffect, useState } from 'react';
import StockMoveTable from './StockMoveTable';
import { Button, Card, Row, Col } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import { toast } from 'react-toastify';
import BasicTemplate from 'components/Toast/BasicTemplate';
import { swalConfirm } from 'components/utilities/SwalToastUtil';
import { stockBulkMove } from 'services/stock-location/stockMovementService';
import { searchs } from 'services/stock-location/stockService';
import { searchProducts } from 'services/stock-location/productService';
import InputScanBinPanel from '../InputScanBinPanel';
import { BaseTableRQ } from 'components/common/models/BaseClass';
import { usePaginationBe } from 'hooks/useBeHandle';

export default function StockMovement() {
  const defaultRQ = new BaseTableRQ(1, 20);
  const [binObj, setBinObj] = useState(undefined);
  const [tableData, setTableData] = useState([]);

  const [total, setTotal] = useState(0);
  const [stocks, setStocks] = useState([]);
  const [paging, setPaging] = useState({ ...defaultRQ });

  const loadStocks = pagingRq => {
    searchs(pagingRq)
      .then(async res => {
        if (!res) return;

        const stockItems = res.items;
        setTotal(res.total);
        setPaging(pagingRq);

        // Get all productIds
        const productIds = stockItems.map(x => x.productId).filter(Boolean);

        // Fetch product info
        const productRes = await searchProducts(productIds);

        // Map product data by id for easy lookup
        const productMap = {};
        if (productRes?.data?.items) {
          productRes.data.items.forEach(p => {
            productMap[p.productId] = p;
          });
        }
        // Merge product info into each stock item
        const mergedStocks = stockItems.map(item => {
          const product = productMap[item.productId] || {};
          return {
            ...item,
            supplierCode: product.supplierCode || '',
            packSize: product.packSize || '',
            mUnitStock: product.mUnitStock || ''
          };
        });
        console.log(mergedStocks);
        setStocks(mergedStocks);
      })
      .catch(err => {
        console.error('❌ loadStocks error:', err);
      });
  };

  useEffect(() => {
    if (binObj) {
      loadStocks({
        ...paging,
        pageNum: 1,
        binBarcode: binObj?.binBarcode,
        productCode: binObj?.filterCode
      });
    }
  }, [binObj]);

  const handleSubmit = async () => {
    swalConfirm('Are you sure?', 'This action cannot be undone.', async () => {
      console.log(tableData);
      await handleBulkStockMove([
        ...tableData.map(x => {
          return { ...x, binBarcode: binObj.binBarcode };
        })
      ]);
      setBinObj({ ...binObj });
    });
  };
  const handleTableChange = updatedData => {
    console.log(updatedData);
    const validRows = Object.values(updatedData)
      .filter(item => item?.bin?.binBarcode && Number(item?.moveQty) > 0)
      .map(item => ({
        stockId: item.id,
        productId: item.productId,
        QtyMove: Number(item.moveQty),
        DesBinBarcode: item.bin.binBarcode
      }));

    setTableData(validRows);
    console.log('✅ valid:', validRows);
  };

  const handleBulkStockMove = async request => {
    console.log(request);
    const moveRq = [
      ...request.map(x => {
        return {
          ...x,
          desBinBarcode: x.desBin,
          productId: x.productId,
          stockId: x.stockId,
          qtyMove: x.moveQty
        };
      })
    ];

    console.log(moveRq);

    let resPatch = await stockBulkMove(moveRq);
    if (resPatch.success) {
      toast.success(<BasicTemplate success={true} text={'All Successed!'} />);
    } else {
      Object.entries(resPatch.data).forEach(([key, value]) => {
        const errItem = moveRq.find(
          x => `${x.stockId}-${x.desBinBarcode}` == key
        );
        if (errItem) {
          toast.error(
            <BasicTemplate
              success={false}
              text={`${errItem.productCode} moved to ${errItem.desBinBarcode} failed: ${value}`}
            />,
            { autoClose: false }
          );
        }
      });
      moveRq.forEach(item => {
        console.log(item);
        if (!resPatch.data[`${item.stockId}-${item.desBinBarcode}`]) {
          toast.success(
            <BasicTemplate
              success={true}
              text={`${item.productCode} moved to ${item.desBinBarcode}  successfully!`}
            />
          );
        }
      });
    }
    return resPatch;
  };

  const { gotoPage, nextPage, previousPage } = usePaginationBe(
    paging,
    total,
    loadStocks
  );

  return (
    <>
      <PageHeader
        title="Stock Movement"
        description={`Manage and view all available stock from this page.`}
        className="mb-3"
      ></PageHeader>

      <InputScanBinPanel
        outputData={bin => {
          setBinObj(bin);
        }}
        binObjIn={binObj}
        displayFilter
      />
      {binObj?.location && (
        <Card>
          <Card.Body className="overflow-hidden p-lg-4">
            <Row className="align-items-center justify-content-between">
              <StockMoveTable
                data={stocks}
                paging={paging}
                total={total}
                nextPage={nextPage}
                previousPage={previousPage}
                gotoPage={gotoPage}
                rowClassName={'clickable'}
                handleInputChange={handleTableChange}
              />
            </Row>
            <Row className="justify-content-center mt-3">
              <Col md={3} className="text-center">
                <Button
                  variant="success"
                  style={{ width: '220px' }}
                  size="sm"
                  onClick={handleSubmit}
                >
                  UPDATE CHANGES
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}
    </>
  );
}
